// extracted by mini-css-extract-plugin
module.exports = {"container":"Icon_container__2LKk2","custom-size":"Icon_custom-size__23A-H"};